import {branch, renderNothing} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getExtensionEndpoint, getIsBuildDetached} from '../../../../../selectors'

import RunningStep from './RunningStep'
import type {OwnProps, StateProps, Props} from './RunningStep.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const extensionEnabled = Boolean(getExtensionEndpoint(state, 'fetchBuildLogTimeline'))
  const detached = getIsBuildDetached(state, props.buildId) ?? false

  return {
    detached,
    extensionEnabled,
  }
}

export default compose(
  connect(mapStateToProps, {}),
  branch(({extensionEnabled}: Props) => !extensionEnabled, renderNothing),
)(RunningStep)
